import { useAvisosEmbudo } from '../../../../Services/API/bff/auto/avisosEmbudo';

/**
 * Advertencias del embudo web EOL (US 23704): avisos de Salesforce que no
 * frenan (ej. una cotizacion duplicada). Sin advertencias no pinta nada.
 */
export const AvisosEmbudo = ({ className = '' }: { className?: string }) => {
    const { avisos, limpiar } = useAvisosEmbudo();
    const mensajes = avisos
        .map((aviso) => (aviso.mensaje || '').trim())
        .filter((mensaje) => !!mensaje);
    if (!mensajes.length) return null;

    return (
        <div className={`alert alert-warning d-flex justify-content-between align-items-start fs-14 mb-3 ${className}`} role="status">
            <ul className="mb-0 ps-3">
                {mensajes.map((mensaje, i) => (
                    <li key={i}>{mensaje}</li>
                ))}
            </ul>
            <button type="button" className="btn-close ms-2" aria-label="Cerrar" onClick={limpiar} />
        </div>
    );
};
